import { ThemeProvider } from '@rneui/themed'
import { appTheme } from 'app/theme'
import React from 'react'

export const DefaultThemeContainer = ({
  children,
}: {
  children: React.ReactNode
}) => <ThemeProvider theme={appTheme}>{children}</ThemeProvider>
